<div class="fixed inset-0 flex items-center justify-center bg-gray-50 z-50">
    @if (status() === 'loading') {
    <div
        class="flex flex-col items-center justify-center text-center bg-white p-2 sm:p-4 rounded-2xl shadow-md w-full max-w-md m-2">
        <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mt-4"></div>
        <div class="mt-6 space-y-2">
            <p class="text-lg font-semibold text-gray-700">Please Wait</p>
            <p class="text-sm text-gray-500">Verifying your documents.</p>
        </div>

        <!-- Countdown -->
        <div class="mt-4 flex flex-col items-center">
            <p class="text-sm text-gray-500">Closing in</p>
            <div class="w-20 h-20 rounded-full bg-blue-50 flex items-center justify-center mt-3">
                <span class="text-4xl  sm:text-5xl font-bold text-blue-600">
                    {{ countdown() }} s
                </span>
            </div>
        </div>
    </div>
    }

    @if (status() === 'success') {
    <div class="rounded-2xl bg-white p-4 sm:p-4 shadow-md">
        <!-- Success Icon -->
        <div class="mb-6 flex justify-center">
            <div class="flex h-20 w-20 items-center justify-center rounded-full bg-green-100">
                <svg class="h-10 w-10 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7" />
                </svg>
            </div>
        </div>

        <!-- Content -->
        <div class="text-center">
            <h1 class="text-xl sm:text-2xl font-semibold text-gray-800">
                KYC Verified Successfully
            </h1>
            <p class="mt-2 text-sm sm:text-base text-gray-500">
                Your identity has been successfully verified through DigiLocker.
            </p>
            <!-- Verification Info -->
            <div class="mt-5 rounded-lg bg-gray-50 p-4 flex items-center justify-center gap-3">
                <div class="flex h-8 w-8 items-center justify-center rounded-full bg-green-100">
                    <svg class="h-4 w-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4" />
                    </svg>
                </div>
                <p class="text-sm font-medium text-gray-700">
                    Identity Verified
                </p>
            </div>
        </div>
        <!-- Button -->
        <div class="mt-6">
            <button (click)="closeBrowser()"
                class="w-full rounded-lg bg-red-600 py-3 text-sm sm:text-base font-medium text-white transition">
                Close
            </button>
        </div>
    </div>
    }


    @if (status() === 'cancelled') {
    <div class="rounded-2xl bg-white p-4 sm:p-4 shadow-md">
        <!-- Cancel Icon -->
        <div class="mb-6 flex justify-center">
            <div class="flex h-20 w-20 items-center justify-center rounded-full bg-red-100">
                <svg class="h-10 w-10 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </div>
        </div>
        <!-- Content -->
        <div class="text-center">
            <h1 class="text-xl sm:text-2xl font-semibold text-gray-800">
                Verification Cancelled
            </h1>
            <p class="mt-2 text-sm sm:text-base text-gray-500">
                You have cancelled the DigiLocker verification process.
            </p>
            <div class="mt-5 rounded-lg bg-red-50 p-4 flex items-center justify-center gap-3">
                <p class="text-sm font-medium text-red-700">
                    Your KYC is not completed yet.
                </p>
            </div>
        </div>
        <!-- Button -->
        <div class="mt-6">
            <button (click)="closeBrowser()"
                class="w-full rounded-lg bg-red-600 py-3 text-sm sm:text-base font-medium text-white transition">
                Close
            </button>
        </div>
    </div>
    }
</div>